export class QuickLink {
  caseId: string;
  createdById: string;
  title: string;
  dateTimeCreated: string;
  isPinned: boolean;
  isShared: boolean;
  lifeCycle: number;
}
